import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomMetricFormatterPipe } from 'src/app/gamification/command-center/custom-pipes/custom-metric-formatter.pipe';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { MetricSelectorComponent } from '../../../../../../reusables/metric-selector/metric-selector.component';
import { MetricSelectorService } from '../../../../../../reusables/metric-selector/metric-selector.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { cloneDeep } from 'lodash';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-connect3-metric-popup',
  templateUrl: './connect3-metric-popup.component.html',
  styleUrls: ['./connect3-metric-popup.component.scss']
})
export class Connect3MetricPopupComponent implements OnInit {
  @Input() parentObj: any;
  
  gs = null;
  firstload = true;
  metricSelected = [];
  metricsSource: string = "Connect3 Choose Metrics";
  isLoadingTargets: boolean = false;
  isLoadedFromCard: boolean = true;
  metricTypeSign: string = null;
  customTarget = {
    MetricID: null,
    Target: null,
    RangedTarget: null,
    Direction: null
  };
  targetMessage: string = "";
  tempObj = {}; //Cancel option.
  validatorMessage: string;
  targetValidatorMessage: string;
  timeoutHandlerDebounce?: NodeJS.Timeout;
    
  constructor(
    private gamesService: GamesService,
    private activeModalService: NgbActiveModal,
    private metricPipe: CustomMetricFormatterPipe,
    private inputRef: ChangeDetectorRef,
    public metricSelectorService: MetricSelectorService,
    private cvConfigService: CvConfigurationService,
    private cvLocalizationService: CVLocalizationService,
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    //Load metric target to check if it has value
    this.loadMetricTargets(); 
    this.cvLocalizationService.GetSection('Games_Module');
  }

  loadMetricTargets(): void {
    if ((this.parentObj.currentPosition != undefined || this.parentObj.currentPosition != null) && this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric != null) {
      this.metricSelected[0]  = this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric
      const target = this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].targetObj;
      // we work with a copy of the original object
      this.customTarget = cloneDeep(target);
      this.metricTypeSign = this.getMetricType(this.metricSelected[0].conversionType);
      //Temporal object in case of user cancel the setting.
      this.tempObj = cloneDeep(target);
    }

    if (this.parentObj.metricSelected) {
      this.metricSelected[0] = this.parentObj.metricSelected[0];
      //Call the MetricType to show message:
      this.checkMetricType(this.metricSelected[0].metricID);
      this.metricTypeSign = this.getMetricType(this.metricSelected[0].conversionType);
    }
    this.customTarget.Target = this.getFormattedMetric(this.customTarget.Target, true); // this change will not affect the object outside this component
  }

  getMetricType(type: string): string {
    switch (type) {
      case "1": return "sec";
      case "2": return "min";
      case "3": return "hr";
      case "4": return "time";
      case "5": return "%";
    }
    return "";
  }

  getLocalization(key: string, defaultText: string): string {
    return this.cvLocalizationService.getCachedText('Games_Module', key, defaultText);
  }

  checkMetricType(metricID: number): void {
    //Call the MetricType to show message:
    this.gamesService.loadMetricTargets(metricID).then((result: any) => {
      this.targetMessage = this.getLocalization(
          "Game_Connect_Des",
          "Square will be marked complete when {0} {1} {2}"
      )
          .replace("{0}", this.metricSelected[0].abbrev)
          .replace("{1}", result.MetricType == 1 ? this.getLocalization("Game_Connect_Des_1", "is maintained at or") : this.getLocalization("Game_Connect_Des_2", "is at or"))
          .replace(
              "{2}",
              this.metricSelected[0].direction == 0
                  ? this.getLocalization(
                        "Game_Connect_Des_3",
                        "below the target value"
                    )
                  : this.getLocalization(
                        "Game_Connect_Des_4",
                        "above the target value"
                    )
          );

      this.inputRef.detectChanges();
    });
  }

  launchMetricSelector () {
    this.validatorMessage = "";
    setTimeout(() =>{
      let selectedMetric = null;
      if (this.metricSelected[0]) {
        const existingMetric = this.metricSelected[0];
        selectedMetric =
        {
          mID: existingMetric.metricID,
          mAbr: existingMetric.abbrev,
          mName: existingMetric.name,
          mDir: existingMetric.direction,
          mCT: existingMetric.conversionType,
        };
      }

      //needed to filter metrics based on game type
      this.metricSelectorService.filterParams = this.gamesService.getGameTypeMetricFilter(this.gs.modified.item.definition.GameType);

      const metricSelector = this.metricSelectorService.openModalForSingleMetric(MetricSelectorComponent, selectedMetric);
      const newSelectedMetrics = [];
      metricSelector.result.then((metricSelectorResult) => {
        if (metricSelectorResult) {
          metricSelectorResult?.forEach(m => {
            newSelectedMetrics.push({
              metricID: m.MetricID,
              abbrev: m.Abbreviation,
              name: m.MetricName,
              conversionType: m.ConversionType,
              direction: m.DefaultDirection,
            });
          });
          this.metricSelected = newSelectedMetrics;
          this.onMetricClicked();
        }
      });
      
      $('#connect3Modal').css('z-index', '1005');
      $('div [uib-modal-backdrop=modal-backdrop]').css('z-index', '1000');
              
      this.parentObj.navigationService.showOverlay = false;
    });
  }

  saveMetricTarget () {
    // we create a copy of the object that we display in the ui, this object is what we will save
    const targetStadardized = cloneDeep(this.customTarget);
    targetStadardized.Target = this.metricPipe.getStandardizedValue(this.customTarget.Target, this.metricSelected[0].conversionType);
    //Validate if the user has selected the metric and the target.
    if (this.validateTarget(targetStadardized)) {
      //Add metric
      targetStadardized.MetricID = this.metricSelected[0].metricID;
      targetStadardized.Direction = this.metricSelected[0].direction;
      if (this.gs.modified.item.SelectedMetrics == null)
          this.gs.modified.item.SelectedMetrics = [];

      if (this.gs.modified.item.SelectedMetrics.filter((e) => { return e.metricID == this.metricSelected[0].metricID }).length > 0) {
        //The metric exists in the list and there's no metric to compare in the position - show error.
        if (this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric == null) {
          this.validatorMessage = this.gamesService.getLocalizedMessage("Connect3_Metric_Already_Selected", "This Metric has already been selected");
          return;
        }
        //The metric exists in the list and it's not in the same position already configured then it's a duplicated metric - show error. 
        if (this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric.metricID != this.metricSelected[0].metricID) {
          this.validatorMessage = this.gamesService.getLocalizedMessage("Connect3_Metric_Already_Selected", "This Metric has already been selected");
          return;
        }
      }
      else {
        //The metric doesn't exist in the list 
        //Check if the metric is null in the position selected - Add metric
        if (this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric == null) {
          this.gs.modified.item.SelectedMetrics.push(this.metricSelected[0]);
        } else {
          //If it's not null then we have to change the metric on this position -- Replace the metric 
          this.gs.modified.item.SelectedMetrics = this.gs.modified.item.SelectedMetrics.map((item) => { 
            return item.metricID === this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric.metricID ? this.metricSelected[0] : item; 
          });
        }
      }

      //Add the metric on the GameBoard
      this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].metric = this.metricSelected[0];
      this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].targetObj = targetStadardized;

      if ((this.gs.modified.item.SelectedMetrics.length == 8 && this.parentObj.hasFreeSpace) || (this.gs.modified.item.SelectedMetrics.length == 9 && !this.parentObj.hasFreeSpace)) {
        var eventArgs = {
          currentStep: this.parentObj.step - 1,
          unlocks: this.parentObj.componentOptions.unlocks
        };
        //unlock next step
        this.parentObj.componentComplete.emit(eventArgs);
      }
    } else {
      return;
    }
    this.close();
  }

  validateTarget (targetStadardized: typeof this.customTarget): boolean {
    if (this.metricSelected.length == 0) {
      //Show message to select a metric.
      this.validatorMessage = this.gamesService.getLocalizedMessage("Connect3_Select_Metric", "Please, select a metric");
      return false;
    }
    if (targetStadardized.Target == undefined || targetStadardized.Target == null || targetStadardized.Target < 0 || targetStadardized.Target.length < 0 || targetStadardized.Target == "") {
      this.targetValidatorMessage = this.gamesService.getLocalizedMessage("Connect3_Target_Value", "The value should be greather than 0");
      return false;
    }
    //Validate  numbers
    if (!this.validateNumber(targetStadardized.Target)) {
      return false;
    }
    return true;
  }

  validateNumber (value): boolean {
    switch (this.metricSelected[0].conversionType) {
      case "0": // "number"
      case "1": // "sec"
      case "2": // "min";
      case "3": // "hr";
      case "4": // "time";
      case "5": // "%";
        if (isNaN(value)) {
          this.targetValidatorMessage = "Please, enter a number or correct format";
          return false;
        }
        break;
    }
    return true;
  }

  cancel (): void {
    //Discard changes
    this.gs.modified.item.Connect3Positions[this.parentObj.currentPosition].targetObj = this.tempObj;
    this.close();
  }

  close(): void {
    this.activeModalService.close();
  }

  validate (e) {
    //Prevent Enter Key
    if (e.keyCode == 13) { e.preventDefault(); }
  }

  formatOnBlur(value): void {
    this.debounceFunction(() => {
        this.customTarget.Target = this.getFormattedMetric(value);
        this.inputRef.detectChanges();
    }, 10);
  }

  getFormattedMetric(value: number, isFirstTime = false): string{
    if(value == null){
      value = 0;
    }
    return this.metricPipe.transform(value, this.metricSelected[0].conversionType, isFirstTime);
  }

  debounceFunction(callback: () => void = () => {}, time: number = 1000) {
    if (this.timeoutHandlerDebounce) clearTimeout(this.timeoutHandlerDebounce);
    this.timeoutHandlerDebounce = setTimeout(()=> {
      callback();
      this.timeoutHandlerDebounce = undefined;
    }, time);
  }

  getLocalizedText(key: string, defaultText: string): string{
    return this.gamesService.getLocalizedMessage(key, defaultText);
  }

  private onMetricClicked(){
    //Call the MetricType to show message:
    this.checkMetricType(this.metricSelected[0].metricID);
    //Show Metric Type
    this.metricTypeSign = this.getMetricType(this.metricSelected[0].conversionType);
  }
}
